import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { OutcomesSection } from './components/OutcomesSection';
import { IncludesSection } from './components/IncludesSection';
import { NotForYouSection } from './components/NotForYouSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-cream text-text font-sans selection:bg-lavender selection:text-text-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <TruthSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <OutcomesSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <NotForYouSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}